<template>
    <div class="container">
        <div class="row border rounded p-3 mb-5">
            <div class="col">
                <h2>Add measurement</h2>
                <div class="mb-3">
                    <label for="distance" class="form-label">RSSI at 1m:</label>
                    <input type="number" id="refRssi" v-model="refRssi" class="form-control" min="-120" max="0">
                </div>
                <div class="mb-3">
                    <label for="distance" class="form-label">Distance (m):</label>
                    <input type="number" id="distance" v-model="distance" class="form-control">
                </div>
                <div class="mb-3">
                    <label for="receivedPower" class="form-label">Received Power (dBm):</label>
                    <input type="number" id="receivedPower" v-model="receivedPower" class="form-control" min="-120" max="0">
                </div>
                <div class="mb-3">
                    <button @click="calculatePathLossExponent" class="btn btn-primary">Add</button>
                </div>
            </div>
            <div class="col">
                <h2>Results</h2>
                <table class="table table-striped table-bordered table-responsive" v-if="calculatedValues.length > 0">
                    <thead class="table-dark">
                        <tr>
                            <th>Distance (m)</th>
                            <th>Received Power (dBm)</th>
                            <th>Path Loss Exponent</th>
                            <th>
                                <button @click="exportCSV" class="btn btn-primary">Export</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="value, i in calculatedValues" :key="i">
                            <td>{{ value.distance }}</td>
                            <td>{{ value.receivedPower }}</td>
                            <td>{{ value.pathLossExponent }}</td>
                            <td>
                                <button @click="deleteValue(i)" class="btn btn-danger">Delete</button>
                            </td>
                        </tr>
                        <tr class="table-dark">
                            <td>Average</td>
                            <td></td>
                            <td>{{ averagePathLossExponent }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <p v-else>No values added yet</p>
            </div>
        </div>
    </div>

</template>


<script>
export default {
    name: 'CalculatorComponent',
    data() {
        return {
            refRssi: null,
            distance: null,
            receivedPower: null,
            pathLossExponent: null,
            averagePathLossExponent: null,
            calculatedValues: []
        }
    },
    methods: {
        calculatePathLossExponent() {
            if (!this.refRssi || !this.distance || !this.receivedPower) {
                alert('Please fill in all fields');
                return;
            }
            if (this.distance <= 1) {
                alert('Distance must be greater than 1');
                return;
            }
            if ((this.receivedPower > 0 || this.receivedPower < -120) || (this.refRssi > 0 || this.refRssi < -120)) {
                alert('RSSI and Received Power must be between -120 and 0');
                return;
            }
            this.pathLossExponent = (this.refRssi - this.receivedPower) / (10 * Math.log10(this.distance));
            this.calculatedValues.push({
                distance: this.distance,
                receivedPower: this.receivedPower,
                pathLossExponent: this.pathLossExponent
            });
            this.averagePathLossExponent = this.calculatedValues.reduce((acc, value) => acc + value.pathLossExponent, 0) / this.calculatedValues.length;
            this.receivedPower = null;
            this.distance = null;
        },
        deleteValue(i) {
            this.calculatedValues.splice(i, 1);
            this.averagePathLossExponent = this.calculatedValues.reduce((acc, value) => acc + value.pathLossExponent, 0) / this.calculatedValues.length;
            if (this.calculatedValues.length === 0) {
                this.averagePathLossExponent = null;
            }
        },
        exportCSV() {
            const headers = ['Distance (m)', 'Path Loss Exponent'];
            const csv = [
                headers.join(','),
                ...this.calculatedValues.map(value => [value.distance, value.pathLossExponent].join(','))
            ].join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'pathLossExponent.csv';
            a.click();
            URL.revokeObjectURL(url);
        }
    }
}
</script>

<style scoped>
.table th {
   text-align: center;   
}
</style>
